export const popupNav = () => {

	//Controls the hover effects for the popup navigation
	const mainNavLinks = document.querySelectorAll('.js__nav-link'); //Get all nav links
	
	if(mainNavLinks.length > 0){ //Make sure there actually are a few !
		mainNavLinks.forEach((navLink) => { //Loop through each and give each link an on hover listener
			navLink.addEventListener('mouseover', (event) => {
				var currentNavHoverIndex = event.target.dataset.item; //Store the index for the current nav item, so we can highlight the appropriate image
				if(currentNavHoverIndex){

					//Keep the nav item we're hovering visible, and reduce opacity on the other nav items (does require another loop though)
					mainNavLinks.forEach((loopNavLink) => {
						if(loopNavLink.dataset.item != currentNavHoverIndex){
							loopNavLink.classList.add('unfocus');
						}else{
							loopNavLink.classList.remove('unfocus');
						}
					})	
						
					//Display the linked image for this nav item
					var navImages = document.querySelectorAll('.main-nav__image');
					if(navImages){
						navImages.forEach((navImage) => {
							if(navImage.dataset.item == currentNavHoverIndex){
								navImage.classList.add('active');
							}else{
								navImage.classList.remove('active');
							}
						})
					}

				}else{ //Not hovering on nav item, make all visible
					mainNavLinks.forEach((loopNavLink) => {
						loopNavLink.classList.remove('unfocus');
					})	
				}
			});

			navLink.addEventListener('mouseleave', (event) => {
				mainNavLinks.forEach((loopNavLink) => {
					loopNavLink.classList.remove('unfocus');
				});
			});
		});
	}else{
		console.warn('No links found for main navigation.');
	}

	toggleNavSubMenus();

	function toggleNavSubMenus() {
		document.querySelectorAll('.js-has-sub-menu').forEach(function(element) {
			element.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Toggle arrow icon state
				e.target.classList.toggle('is-active');
				
				const subMenu = e.target.parentElement.nextElementSibling;
				// If closing sub-menu
				if (subMenu.classList.contains('is-active')) {
					subMenu.classList.remove('is-active');
					setTimeout(function() {
						slideToggle(subMenu, 500);
					}, 400);
				} 
				// If opening sub-menu
				else {
					slideToggle(subMenu, 500);
					subMenu.classList.add('is-active');
				}
			});
		});
	
	}
	
	// Helper function to toggle display with animation
	function slideToggle(element, duration = 500) {
		if (window.getComputedStyle(element).display === 'none') {
			element.style.display = 'block';
			let height = element.scrollHeight;
			element.style.height = '0';
			element.style.overflow = 'hidden';
			element.style.transition = `height ${duration}ms ease`;
			requestAnimationFrame(() => {
				element.style.height = height + 'px';
			});
			setTimeout(() => {
				element.style.height = '';
				element.style.overflow = '';
				element.style.transition = '';
			}, duration);
		} else {
			let height = element.scrollHeight; // Ensure the current height is set
			element.style.height = height + 'px';
			element.style.overflow = 'hidden';
			element.style.transition = `height ${duration}ms ease`;
			requestAnimationFrame(() => {
				element.style.height = '0';
			});
			setTimeout(() => {
				element.style.display = 'none';
				element.style.height = '';
				element.style.overflow = '';
				element.style.transition = '';
			}, duration );
		}
	}
}